module.exports = __webpack_public_path__ + "static/media/30OIOS4.084315a5.jpg";